import React, { useState, useCallback } from 'react';
import {
  Card,
  Form,
  FormLayout,
  TextField,
  Select,
  Button,
  Banner,
  InlineStack,
} from '@shopify/polaris';
import { useAppBridge } from '@shopify/app-bridge-react';
import { getSessionToken } from '@shopify/app-bridge/utilities';
import { ProductPicker } from './ProductPicker';

export function CreateBundleForm() {
  const app = useAppBridge();
  const [title, setTitle] = useState('');
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [discountType, setDiscountType] = useState('percentage');
  const [discountValue, setDiscountValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = useCallback(async (event) => {
    event.preventDefault();
    try {
      setLoading(true);
      setErrorMessage('');
      setSuccessMessage('');
      
      const token = await getSessionToken(app);
      
      const response = await fetch('/api/bundle/save', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          title,
          productIds: selectedProducts,
          discountType,
          discountValue: Number(discountValue)
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to save bundle');
      }

      // Reset form
      setTitle('');
      setSelectedProducts([]);
      setDiscountValue('');
      setSuccessMessage('Bundle created successfully!');
      
    } catch (error) {
      console.error('Error saving bundle:', error);
      setErrorMessage(error.message);
    } finally {
      setLoading(false);
    }
  }, [app, title, selectedProducts, discountType, discountValue]);

  return (
    <Card>
      <Card.Section>
        <Form onSubmit={handleSubmit}>
          <FormLayout>
            {errorMessage && (
              <Banner status="critical">
                <p>{errorMessage}</p>
              </Banner>
            )}
            
            {successMessage && (
              <Banner status="success">
                <p>{successMessage}</p>
              </Banner>
            )}

            <TextField
              label="Bundle Title"
              value={title}
              onChange={setTitle}
              autoComplete="off"
              error={title.length === 0 ? 'Title is required' : undefined}
            />
            
            <ProductPicker
              selectedProducts={selectedProducts}
              onChange={setSelectedProducts}
            />
            
            <Select
              label="Discount Type"
              options={[
                {label: 'Percentage', value: 'percentage'},
                {label: 'Fixed Amount', value: 'fixed'}
              ]}
              value={discountType}
              onChange={setDiscountType}
            />
            
            <TextField
              label="Discount Value"
              value={discountValue}
              onChange={setDiscountValue}
              type="number"
              suffix={discountType === 'percentage' ? '%' : '$'}
              error={!discountValue ? 'Discount value is required' : undefined}
            />
            
            <InlineStack align="end">
              <Button
                primary
                submit
                loading={loading}
                disabled={!title || selectedProducts.length < 2 || !discountValue}
              >
                Create Bundle
              </Button>
            </InlineStack>
          </FormLayout>
        </Form>
      </Card.Section>
    </Card>
  );
} 